import { useState, useEffect } from 'react';
import { useFetchProducts } from '../../data/swrs/shopify';
import tagApi from '@/api/tagApi';

export const useFilters = (type = '') => {
	const [selectedTags, setSelectedTags] = useState([]);
	const [selectedDurations, setSelectedDurations] = useState([]);
	const [selectedInstructors, setSelectedInstructors] = useState([]);
	const [selectedLevels, setselectedLevels] = useState([]);
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [tags, setTags] = useState([]);
	const [instructors, setInstructors] = useState([]);
	const [products, setProducts] = useState([
		{
			name: '',
			id: '',
			subname: ''
		}
	]);
	const [sortby, setSortBy] = useState('');
	const { data } = useFetchProducts(type);
	const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
	const [durationValue, setDurationValues] = useState([])

	// Fetch tags
	useEffect(() => {
		tagApi.getActiveTags().then(filteredTags => {
			setTags(filteredTags);
		});
	}, []);

	// Format products from API data
	useEffect(() => {
		if (data?.products) {
			const formattedProducts = data.products.map(product => ({
				name: product?.title,
				id: product?._id,
				subname: product?.metafieldValue || ''
			}));

			setProducts(formattedProducts);
		}
	}, [data]);

	const handleFilterChange = event => {
		setSortBy(event.target.value);
	};

	const handleOpenFilterModal = () => {
		setIsFilterModalOpen(true);
	};

	const handleCloseFilterModal = () => {
		setIsFilterModalOpen(false);
	};

	const handleApplyFilter = (tags, durations, levels, instructors, products) => {
		setSelectedTags(tags);
		setselectedLevels(levels);
		setSelectedDurations(durations);
		setSelectedInstructors(instructors);
		setSelectedProducts(products);
		setIsFilterModalOpen(false);
	};

	const handleResetFilter = () => {
		setSelectedTags([]);
		setSelectedDurations([]);
		setselectedLevels([]);
		setSelectedInstructors([]);
		setSelectedProducts([]);
	};

	return {
		tags,
		durationValue,
		instructors,
		products,
		setInstructors,
		selectedTags,
		setSelectedTags,
		setDurationValues,
		selectedDurations,
		setSelectedDurations,
		selectedLevels,
		selectedInstructors,
		setSelectedInstructors,
		selectedProducts,
		setSelectedProducts,
		sortby,
		handleFilterChange,
		handleApplyFilter,
		handleResetFilter,
		isFilterModalOpen,
		setIsFilterModalOpen,
		handleOpenFilterModal,
		handleCloseFilterModal,		
	};
};
